
















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class TextArea extends Vue {
  @Prop()
  public value!: string;

  @Prop({ default: 'light' })
  public variant!: 'light' | 'dark' | 'outline';

  @Prop({ default: false })
  public hasError!: boolean;

  public mounted() {
    // this is necessary for IE11 because the @blur event does not include the relatedtarget correctly in IE11
    (this.$refs.area as HTMLAreaElement).addEventListener('focusout', (event) => this.$emit('focusout', event));
  }

  public beforeDestroy(): void {
    (this.$refs.area as HTMLAreaElement).removeEventListener('focusout', (event) => this.$emit('focusout', event));
  }

  public get otherListeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  public focus(): void {
    (this.$refs.area as HTMLAreaElement)?.focus();
  }
}
